import {
  AfterContentInit,
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { SideNavigationItem } from '../../atlas_sdk/api';
import { BusinessNavConfigService, Config } from '../../config.service';
import { AtlasTranslateService } from '../../translate/translate.service';
import { replaceUrlTokens } from '../util';

@Component({
  selector: 'atlas-nav-item-section',
  templateUrl: './nav-item-section.component.html',
  styleUrls: ['./nav-item-section.component.scss']
})
export class NavItemSectionComponent implements OnInit, AfterViewInit, AfterContentInit, OnDestroy {
  @Input() label: string;
  @Input() translationId: string;
  @Input() indentation: number;
  @Input() startOpen: boolean;
  @Input() children: SideNavigationItem[];
  @Input() chipContent: string;
  @ViewChild('section', { static: true }) section: ElementRef;
  text$: Observable<string>;

  private opened$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public opened$: Observable<boolean> = this.opened$$.asObservable();
  private subs: Subscription[] = [];

  constructor(private renderer: Renderer2,
              private t: AtlasTranslateService, private configService: BusinessNavConfigService,
              private router: Router) {
  }

  get sectionHeight(): number {
    return this.section.nativeElement.offsetHeight;
  }

  ngOnInit(): void {
    this.text$ = this.t.stream(this.translationId, this.label);
    if (this.startOpen) {
      this.open();
    }
  }

  ngAfterContentInit(): void {
    const config = this.configService.getCurrentConfig();
    if (this.checkChildrenForActiveRoute(this.children, config)) {
      this.open();
    }
  }

  ngOnDestroy(): void {
    this.subs.map((sub: Subscription) => sub.unsubscribe());
  }

  private open(): void {
    if (this.opened$$.getValue()) {
      return;
    }
    this.updateRendererStyle(true);
    this.opened$$.next(true);
  }

  public toggle(): void {
    const toggledValue = !this.opened$$.getValue();
    this.updateRendererStyle(toggledValue);
    this.opened$$.next(toggledValue);
  }

  updateRendererStyle(open: boolean): void {
    if (open) {
      this.renderer.setStyle(this.section.nativeElement, 'margin-top', '0');
    } else {
      this.renderer.setStyle(this.section.nativeElement, 'margin-top', -this.sectionHeight + 'px');
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.updateRendererStyle(this.opened$$.getValue()), 0);
  }

  private checkChildrenForActiveRoute(children: SideNavigationItem[], config: Config): boolean {
    let active = false;
    if (!children || children.length === 0) {
      return active;
    }

    const curPath = `/${this.router.parseUrl(this.router.url).root.children.primary.toString()}`;

    for (const child of children) {
      if (!!child.sideNavigationSection) {
        active = this.checkChildrenForActiveRoute(child.sideNavigationSection.sideNavigationItems, config);
      } else if (!!child.sideNavigationContainer) {
        active = this.checkChildrenForActiveRoute(child.sideNavigationContainer.sideNavigationItems, config);
      } else if (child.sideNavigationLink.serviceProviderId === config.serviceProviderId) {
        active = curPath === replaceUrlTokens(child.sideNavigationLink.path, config.accountId, config.groupPath);
      }

      if (active) {
        break;
      }
    }

    return active;
  }
}
